/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as msRest from "@azure/ms-rest-js";


export const MenuLevel: msRest.CompositeMapper = {
  serializedName: "MenuLevel",
  type: {
    name: "Composite",
    className: "MenuLevel",
    modelProperties: {
      path: {
        required: true,
        serializedName: "Path",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number"
            }
          }
        }
      },
      hasItems: {
        serializedName: "HasItems",
        type: {
          name: "Boolean"
        }
      },
      label: {
        required: true,
        serializedName: "Label",
        type: {
          name: "String"
        }
      },
      url: {
        required: true,
        serializedName: "Url",
        type: {
          name: "String"
        }
      },
      items: {
        serializedName: "Items",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MenuLevel"
            }
          }
        }
      },
      isActive: {
        required: true,
        serializedName: "IsActive",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const Lookup: msRest.CompositeMapper = {
  serializedName: "Lookup",
  type: {
    name: "Composite",
    className: "Lookup",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      text: {
        serializedName: "text",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number"
            }
          }
        }
      }
    }
  }
};

export const MenuResponse: msRest.CompositeMapper = {
  serializedName: "MenuResponse",
  type: {
    name: "Composite",
    className: "MenuResponse",
    modelProperties: {
      menuItems: {
        required: true,
        serializedName: "MenuItems",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MenuLevel"
            }
          }
        }
      },
      pathLookup: {
        required: true,
        serializedName: "PathLookup",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "Lookup"
            }
          }
        }
      }
    }
  }
};
